<template>
  <div>
    <div class="content">
      <img src="../../../../assets/img/fish.png" />
      <div class="success">
        <span>提交成功</span>
      </div>
      <div class="text1">您的展位现场预定申请已提交</div>
      <div class="text2">
        我们将尽快通知您是否预定成功，请注意查收邮件，并保持电话畅通
      </div>
      <div class="btn" @click="back">
        <span> 返回 </span>
      </div>

      <div
        class="btn"
        @click="backToId"
        style="border: 1px solid #16d1d1; background-color: #fff"
      >
        <span style="color: #16d1d1"> 继续预订其他展位 </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    backToId() {
      this.$router.push({
        path: "/basic/mobile",
        query: { userId: this.$route.query.userId },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  padding: 2.46rem 0.3rem;
  text-align: center;
  img {
    width: 1.7rem;
    height: 1.7rem;
  }
  .success {
    margin-top: 0.33rem;
    margin-bottom: 0.33rem;
    span {
      font-size: 0.6rem;
      color: #16d1d1;
    }
  }
  .text1 {
    font-size: 0.5rem;
    color: #333;
    margin-bottom: 0.26rem;
    font-weight: 500;
  }
  .text2 {
    width: 5.44rem;
    margin: 0 auto;
    color: #999;
    font-size: 0.3rem;
    line-height: 0.64rem;
  }
  .btn {
    height: 1rem;
    background-color: #16d1d1;
    border-radius: 1rem;
    margin-top: 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: #fff;
      font-size: 0.36rem;
    }
  }
}
</style>
